export default __webpack_public_path__ + "static/media/mac.70227095.png";